module.exports = __webpack_public_path__ + "img/20190713124907739.3c0b2a81.png";